import React, { useEffect, useState } from 'react';
import axios from '../../plugins/axios'
import Toast from '../../plugins/useToast'
import { useTranslation } from 'react-i18next';

import {ReactComponent as IconError} from '../../assets/icons/ic-error.svg'
import {ReactComponent as IconClose} from '../../assets/icons/ic-close.svg'
import {ReactComponent as IconSuccess} from '../../assets/icons/ic-success.svg'

const UserInfoModal = ({ onClose }) => {
    const { t } = useTranslation()
    const [isDisabled, setIsDisabled] = useState(false)
    const [userInfo, setUserInfo] = useState({
        name: '', loginId: '', departmentId: '', departmentName: '', phoneNumber: ''
    })
    const [oldInfo, setOldInfo] = useState({})
    const [curPass, setCurPass] = useState('')
    const [newPass, setNewPass] = useState('')
    const [newPassConfirm, setNewPassConfirm] = useState('')
    const [isPasswordChangeShow, setIsPasswordChangeShow] = useState(false)

    const getUserInfo = async () => {
        try {
            const res = await axios.get('/user/me')
            if (res.code != '200') throw res
            console.log('userInfo.department : ', res.data);
            setUserInfo({ ...res.data })
            setOldInfo({ ...res.data })
            setIsDisabled(true)
        } catch (err) {
            console.warn(err);
        }
    };    

    // 저장 성공
    const handleSave = async () => {
        if (isPasswordChangeShow) {
            if (!curPass) {
                Toast({ isSuccess: false, msg: t('userInfo.inputCurrentPassword') })
                return
            }
            if (newPass) {
                if (newPass.length < 8 ||
                    newPass.length > 16 ||
                    !/[a-z]/.test(newPass) ||
                    !/[0-9]/.test(newPass) ||
                    !/[^a-zA-Z0-9]/.test(newPass) ||
                    newPass !== newPassConfirm
                ) {
                    Toast({ isSuccess: false, msg: t('userInfo.checkNewPassword') })
                    return
                }
            }
        }
        try {
            if (isPasswordChangeShow && newPass) {
                const res = await axios.put('/user/me/password', { newPassword: newPass, oldPassword: curPass })
                if (res.code != '200') throw res
            }            
            const saveRes = await axios.put('/user/me', { name: userInfo.name, departmentId: userInfo.departmentId, email: userInfo.email, phoneNumber: userInfo.phoneNumber, loginId: userInfo.loginId })
            if (saveRes.code != '200') throw saveRes
            else {
                Toast({ isSuccess: true })
                setOldInfo({ ...userInfo })
                if (isPasswordChangeShow && newPass) {
                    setCurPass('')
                    setNewPass('')
                    setNewPassConfirm('')
                    setIsPasswordChangeShow(false)
                }
                setIsDisabled(true)
            }

        } catch (err) {
            Toast({ isSuccess: false, msg: err.message || t('userInfo.retryLater') })
        }
    };

    useEffect(() => {
        if (userInfo.name !== oldInfo.name || 
            userInfo.loginId !== oldInfo.loginId ||
            userInfo.department !== oldInfo.department ||
            userInfo.phoneNumber !== oldInfo.phoneNumber ||
            isPasswordChangeShow
        ) {
            setIsDisabled(false)
        } else {
            setIsDisabled(true)
        }
    }, [isPasswordChangeShow, userInfo])

    useEffect(() => {
        getUserInfo();        
    }, []);

    return (
        <div className="relative w-full h-full bg-black max-h-[520px] font-normal border-t border-white">
            <div className="bg-[#1F1F1F] w-full h-full">
                <div className="flex justify-between items-center h-[32px]">
                    <h2 className="text-lg font-normal text-[white] m-[6px] ml-5">{t('userInfo.title')}</h2>
                    <div className="flex items-center">
                        <button className={`w-[88px] h-[28px] absolute top-[3px] right-[40px] rounded-[6px] font-light
                                ${isDisabled? ' bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'
                                : ' text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'}
                                active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                            disabled={isDisabled}
                            onClick={() => { handleSave() }}
                        >
                            {isDisabled ? t('userInfo.saved') : t('userInfo.save')}
                        </button>
                        <IconClose onClick={() => { onClose() }} className="m-[10px] cursor-pointer"/>
                    </div>
                </div>
                <div className="pl-5 pt-3 text-white flex" style={{ height: 'calc(100% - 72px)' }}>
                    <div className="flex flex-col">
                        <div className="flex items-center h-[32px]">
                            <div className="font-light mr-4" style={{ minWidth: 120, maxWidth: 120 }}>{t('userInfo.name')}</div>
                            <div className="w-[402px] h-[32px]" style={{ borderRadius: 6, padding: '7px 8px', background: '#2C2C2C80'}}>
                                {userInfo.name}
                            </div>
                        </div>
                        <div className="flex items-center h-[32px] mt-6">
                            <div className="font-light mr-4" style={{ minWidth: 120, maxWidth: 120 }}>{t('userInfo.account')}</div>
                            <div className="w-[402px] h-[32px]" style={{ borderRadius: 6, padding: '7px 8px', background: '#2C2C2C80'}}>
                                {userInfo.loginId}
                            </div>
                        </div>
                        {
                            !isPasswordChangeShow &&
                            <div className="flex items-center h-[32px] mt-6">
                                <div className="font-light mr-4" style={{ minWidth: 120, maxWidth: 120 }}>{t('userInfo.password')}</div>
                                <div className="w-[402px] h-[32px] flex items-center" style={{ }}>
                                    <div className="w-[244px]" style={{ borderRadius: 6, padding: '7px 8px', background: '#2C2C2C80'}}>**********</div>
                                    <div onClick={() => { setIsPasswordChangeShow(true) }}className="flex items-center justify-center h-[28px] cursor-pointer font-light flex-1 ml-2 bg-gradient-to-b from-[#5E5E5E] to-[#383838]" style={{ borderRadius: 6, padding: '7px 8px', border: '1px solid #5E5E5E', boxShadow: '0px 4px 4px 0px #00000066' }}>{t('userInfo.changePassword')}</div>
                                </div>
                            </div>
                        }
                        <div className="flex items-center h-[32px] mt-6">
                            <div className="font-light mr-4" style={{ minWidth: 120, maxWidth: 120 }}>{t('userInfo.department')}</div>
                            <div className="w-[402px] h-[32px]" style={{ borderRadius: 6, padding: '7px 8px', background: '#2C2C2C80'}}>
                                {userInfo.departmentName || '-'}
                            </div>
                        </div>
                        <div className="flex items-center h-[32px] mt-6">
                            <div className="font-light mr-4" style={{ minWidth: 120, maxWidth: 120 }}>{t('userInfo.phoneNumber')}</div>
                            <div className="w-[402px] h-[32px]" style={{ borderRadius: 6, padding: '7px 8px', background: '#2C2C2C80'}}>
                                <input className="w-full" value={userInfo.phoneNumber} 
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^0-9-+]/g, '');
                                        setUserInfo({ ...userInfo, phoneNumber: value });
                                    }}
                                    type='text' 
                                    style={{ outline: 'none', border: 'none', backgroundColor: 'transparent' }} 
                                />
                            </div>
                        </div>
                    </div>
                    {
                        isPasswordChangeShow &&
                        <div className="ml-8 pl-8 flex flex-col" style={{ borderLeftWidth: 1, borderColor: '#444444' }}>
                            <div className="flex items-center h-[32px]">
                                <div className="font-light mr-4" style={{ minWidth: 120, maxWidth: 120 }}>{t('userInfo.currentPassword')}</div>
                                <div className="w-[402px] h-[32px]" style={{ borderRadius: 6, padding: '7px 8px', background: '#2C2C2C80'}}>
                                    <input className="w-full" value={curPass} onChange={(e) => { setCurPass(e.target.value) }} type='password' style={{ outline: 'none', border: 'none', backgroundColor: 'transparent' }} />
                                </div>
                            </div>
                            <div className="flex items-center h-[32px] mt-6">
                                <div className="font-light mr-4" style={{ minWidth: 120, maxWidth: 120 }}>{t('userInfo.newPassword')}</div>
                                <div className="w-[402px] h-[32px]" style={{ borderRadius: 6, padding: '7px 8px', background: '#2C2C2C80'}}>
                                    <input className="w-full" value={newPass} onChange={(e) => { setNewPass(e.target.value) }} type='password' style={{ outline: 'none', border: 'none', backgroundColor: 'transparent' }} />
                                </div>
                            </div>
                            <div className="flex items-center mt-2">
                                <div className="font-light mr-4" style={{ minWidth: 120, maxWidth: 120 }}></div>
                                <div className="w-[402px]" style={{ }}>
                                    <div className="flex items-center" style={{ color: newPass.length > 0 ? /[a-z]/.test(newPass) ? '#146830' : '#C50024' : '#5E5E5E' }}>
                                        {
                                            newPass.length > 0 &&
                                            (/[a-z]/.test(newPass) ? <IconSuccess className="mr-1"/> : <IconError className="mr-1"/>)
                                        }
                                        {t('userInfo.oneLowercaseLetter')}
                                    </div>
                                    <div className="flex items-center mt-1" style={{ color: newPass.length > 0 ? /[0-9]/.test(newPass) ? '#146830' : '#C50024' : '#5E5E5E' }}>
                                        {
                                            newPass.length > 0 &&
                                            (/[0-9]/.test(newPass) ? <IconSuccess className="mr-1"/> : <IconError className="mr-1"/>)
                                        }
                                        {t('userInfo.oneNumber')}
                                    </div>
                                    <div className="flex items-center mt-1" style={{ color: newPass.length > 0 ? /[^a-zA-Z0-9]/.test(newPass) ? '#146830' : '#C50024' : '#5E5E5E' }}>
                                        {
                                            newPass.length > 0 &&
                                            (/[^a-zA-Z0-9]/.test(newPass) ? <IconSuccess className="mr-1"/> : <IconError className="mr-1"/>)
                                        }
                                        {t('userInfo.oneSpecial')}
                                    </div>
                                    <div className="flex items-center mt-1" style={{ color: newPass.length > 0 ? (newPass.length >= 8 && newPass.length <= 16) ? '#146830' : '#C50024' : '#5E5E5E' }}>
                                        {
                                            newPass.length > 0 &&
                                            ((newPass.length >= 8 && newPass.length <= 16) ? <IconSuccess className="mr-1"/> : <IconError className="mr-1"/>)
                                        }
                                       {t('userInfo.characterNum')}
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center h-[32px] mt-6">
                                <div className="font-light mr-4" style={{ minWidth: 120, maxWidth: 120, lineHeight: '110%' }}>{t('userInfo.confirmPassword')}</div>
                                <div className="w-[402px] h-[32px]" style={{ borderRadius: 6, padding: '7px 8px', background: '#2C2C2C80'}}>
                                    <input className="w-full" value={newPassConfirm} onChange={(e) => { setNewPassConfirm(e.target.value) }} type='password' style={{ outline: 'none', border: 'none', backgroundColor: 'transparent' }} />
                                </div>
                            </div>
                            <div className="flex items-center mt-2">
                                <div className="font-light mr-4" style={{ minWidth: 120, maxWidth: 120 }}></div>
                                <div className="w-[402px] h-[32px]" style={{ }}>
                                    <div className="flex items-center" style={{ color: newPassConfirm.length > 0 ? newPass === newPassConfirm ? '#146830' : '#C50024' : '#5E5E5E' }}>
                                        {
                                            newPassConfirm.length > 0 &&
                                            ((newPass === newPassConfirm) ? <IconSuccess className="mr-1"/> : <IconError className="mr-1"/>)
                                        }
                                        {t('userInfo.sameNewPassword')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};


export default UserInfoModal;
